/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './content/content.props';
export {registerProps as ɵc} from './page-content/page-content.props';
export {registerProps as ɵa} from './page.props';